import type { ClientDevice } from '@maru44/huntre-utils/src/models/clientDevice'
import { Box, Switch, Typography } from '@mui/material'
import type { FC } from 'react'

type Props = {
  clientDevice: ClientDevice
  disabled?: boolean
  onUpdate: () => Promise<void>
  // 現在の状態(オン/オフ)ラベルを表示する
  showStatusLabel?: boolean
}

export const ClientDeviceSwitch: FC<Props> = ({ clientDevice, disabled, onUpdate, showStatusLabel = true }) => {
  const isOn = !clientDevice.isTurnedOff

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <Switch checked={isOn} onChange={onUpdate} color="success" disabled={disabled} />
      {showStatusLabel && (
        <Typography
          variant="body2"
          color={isOn ? 'success.main' : 'text.secondary'}
          sx={{
            fontWeight: 600,
          }}
        >
          {isOn ? 'オン' : 'オフ'}
        </Typography>
      )}
    </Box>
  )
}
